import { useState } from "react";
import { FormattedMessage as FM } from "react-intl";

import Dialog from "componentsv2/modal/Dialog";
import { BUTTON_COLORS } from "components/Constants/constants";
import { useWizard } from "storev2/wizardStore";
import { cn } from "tools/ui";
import { SIZES } from "./constants";

const base =
  "flex mx-auto shadow-md py-2 px-3 h-12 border rounded-lg hover:bg-neutral-300 active:scale-95 cursor-pointer";

function ButtonWizard(props) {
  const {
    children,
    openModal,
    styleBtn,
    label,
    buttons,
    layout,
    icon,
    color,
    resetData,
    onReset,
  } = props;
  const [msg, setMsg] = useState(null);

  const _color = color ?? "blue";
  // let _style = style ?? "w-full";
  // const [bgColor, txtColor, border] = BUTTON_COLORS[_color];
  const bgColor = "bg-white";

  function onCloseMsg() {
    setMsg(null);
  }

  async function onClose(update, error) {
    if (error) {
      setMsg(error);
      reset();
      return;
    }

    openModal.value = false;
    const { reset } = useWizard.getState();
    reset();
    if (resetData) {
      for (const field of Object.values(resetData)) {
        field.value = null;
      }
    }
    if (onReset) {
      onReset();
    }
  }

  function clickOpen() {
    if (layout?.defaults) {
      // This method set default values for the wizard
      layout.defaults();
    }
    openModal.value = true;
  }

  return (
    <div>
      <button
        type="button"
        onClick={clickOpen}
        className={cn(base, bgColor, styleBtn)}
      >
        {icon}
        <span className={cn("min-w-30 my-auto")}>
          <FM id={label} />
        </span>
      </button>
      <Dialog
        title={label}
        openModal={openModal}
        handleClose={onClose}
        buttons={buttons}
        titleSize="text-2xl"
        size="h-4/5 w-1/2"
      >
        {children}
      </Dialog>
    </div>
  );
}

export default ButtonWizard;
